import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CreateTicket from './createTicket';
import { saveFdTicket } from "services/redux/maintenance/freshdesk/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      documentUploadUrlPublic,
      saveFdTicket,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CreateTicket);
